import periodicitiesData from './periodicities.json';
/*
https://console-espaceclient-rec.apavetest.com/
https://console-espaceclient-pp.apavetest.com/
http://localhost:3001/

live
https://console-espaceclient.apave.com/
*/
export const serverURL = 'https://console-espaceclient.apave.com/';


/*
http://localhost:3001/v1/
https://espaceclient-pp.apavetest.com/v1/

live
https://espaceclient.apave.com/v1/
*/
export const userspaceURL = 'https://espaceclient.apave.com/v1/';
// export const userspaceURL = 'https://espaceclient.apave.com/v1/';


export const drupalURL = 'https://apave.fr/jsonapi/' // 'https://pp.apave.fr/jsonapi/'
export const trainingAPI = `${serverURL}api/`


export const privacyURL = `${serverURL}privacy`;
export const logoURL = `${serverURL}assets/logos/`;
export const apiURL = `${serverURL}v1/`;
export const profileURL = `${serverURL}profiles/`;

export const avertinonpremiumURL = `https://alertsantesecurite.apave.com/v1/`; //appid == 2000

export const PERPAGE = 30;
export const PERPAGE100 = 100;
export const ROLE_SUPPORT = 'support';
export const ROLE_INTER_USER = 'interuser';
export const ROLE_INTER_CLIENT = 'interclient';
export const ROLE_APAVE_CLIENT = 'apaveclient';
export const ROLE_PROJECT_CLIENT = 'projectclient';
export const ROLE_ADMIN = 'admin';
export const ROLE_CLIENT = 'client';
export const ROLE_USER = 'user';
export const USER_ROLES = [ROLE_CLIENT, ROLE_ADMIN, ROLE_USER];

export const CATALOGUE_APAVE_TEAM = "6231c96b7fcdd8500ff28e49"; //"Former vos équipes avec Apave"
export const CATALOGUE_APAVE_TEAM_PUBLIC = "636a0056fcb10cda72dbbba5";
export const CATALOGUE_APAVE_TEAM_SERVICE = "63ff5c95a003c298ab34714b"; //"Vérifier votre conformité"
export const CATALOGUE_APAVE_TEAM_SERVICE_PUBLIC = "64004435fcb10cda72011ded";

export const GOOGLE_MAP_APIKEY = "AIzaSyBmA65jwtGzbFP35lNY59yVpcTpBaGYHh0";

export const statues = ['Registered', 'Confirmed', 'Blocked'];
export const USER_STATUS_REGISTERED = statues[0];
export const USER_STATUS_CONFIRMED = statues[1];

export const MEMBERSHIPS = ['START', 'PREMIUM', 'EXCLUSIVE'];
export const MEMBERSHIP_START = 'START';
export const MEMBERSHIP_PREMIUM = 'PREMIUM';
export const MEMBERSHIP_EXCLUSIVE = 'EXCLUSIVE';

export const EXPORT_MODE_EXCEL = 'excel';
export const EXPORT_MODE_CSV = 'csv';

export const NO_CLIENT_ID = '0000';

export const PRODUCT_MODEL_FIELD_TYPES = [
    'TEXT',
    'NUMERIC',
    'DATE',
    'TIME',
    'DATE/TIME'
];

export const PRODUCT_MODEL_FIELD_TYPE_TEXT = PRODUCT_MODEL_FIELD_TYPES[0];
export const PRODUCT_MODEL_FIELD_TYPE_NUMERIC = PRODUCT_MODEL_FIELD_TYPES[1];
export const PRODUCT_MODEL_FIELD_TYPE_DATE = PRODUCT_MODEL_FIELD_TYPES[2];
export const PRODUCT_MODEL_FIELD_TYPE_TIME = PRODUCT_MODEL_FIELD_TYPES[3];
export const PRODUCT_MODEL_FIELD_TYPE_DATETIME = PRODUCT_MODEL_FIELD_TYPES[4];

export const PRODUCT_TYPES = [
    'training', //02 = Formations
    'services' //01 = Prestations
];
export const PRODUCT_TYPE_TRAINING = PRODUCT_TYPES[0];
export const PRODUCT_TYPE_SERVICES = PRODUCT_TYPES[1];


export const CATALOGUE_TYPE_NATIONAL = 'national' // Catalogue Contract National
export const CATALOGUE_TYPE_GENERAL = 'general' //Catalogue Générique
export const CATALOGUE_TYPE_ESSENTIAL = 'essential' //Catalogue Générique Essentiel
export const CATALOGUE_TYPE_PACK = 'pack'

export const CATALOGUE_TYPES = [
    CATALOGUE_TYPE_NATIONAL,
    CATALOGUE_TYPE_GENERAL,
    CATALOGUE_TYPE_ESSENTIAL,
    CATALOGUE_TYPE_PACK
];

export const INDUSTRY_VALUES = [
    'industrial-products-manufacturing', //Produits industriels et fabrication, 
    'energies', //Energies, 
    'infrastructure', //Infrastructure, 
    'construction', //Construction, 
    'transport', //Transport, 
    'food-industry', //Agroalimentaire, 
    'automotive', //Automobile, 
    'consumer-distribution', //Biens de consommation et distribution, 
    'health-medico-social', //Santé et Médico Social, 
    'public-services-local-communities', //Services publics et collectivités locales, 
    'telecommunications-digital', //Télécommunications et Digital, 
    'tertiary', //Tertiaire, 
    'small-businesses-SMEs-selfemployed-workers' //très petites entreprises/PME/travailleurs indépendants
];

export const YOURNEEDS = [
    'train-teams', //Train your teams
    'check-compliance', //Check your compliance
    'operate-renovate', // Build, operate and renovate safely
    'operate-complete', //Operate in complete safety
    'preserving-health', //Preserving health and safety at work
    'audit-certify', // Audit - Certify - Label
    'environmental', //Take environmental samples
    'test-qualify', //Test and qualify your products
]

export const PRODUCT_PROCESS_TYPES = [
    'intra',
    'inter'
];

export const PRODUCT_PROCESS_TYPE_INTRA = PRODUCT_PROCESS_TYPES[0];
export const PRODUCT_PROCESS_TYPE_INTER = PRODUCT_PROCESS_TYPES[1];

export const CURRENCIES = [
    'EUR',
    'USD',
    'GBP'
]
export const CUSTOM_FIELD_TYPE_TEXT = 'text';
export const CUSTOM_FIELD_TYPE_NUMERIC = 'numberic';
export const CUSTOM_FIELD_TYPE_CHECKBOX = 'checkbox';
export const CUSTOM_FIELD_TYPE_DROPDOWN_TEXT = 'dropdown_text';
export const CUSTOM_FIELD_TYPE_DROPDOWN_MULTI = 'dropdown_multi';
export const CUSTOM_FIELD_TYPE_CAPTCHA = 'captcha';

export const SITE_FIELD_TYPES = [
    CUSTOM_FIELD_TYPE_TEXT,
    CUSTOM_FIELD_TYPE_NUMERIC,
    CUSTOM_FIELD_TYPE_CHECKBOX,
    CUSTOM_FIELD_TYPE_DROPDOWN_TEXT,
    CUSTOM_FIELD_TYPE_DROPDOWN_MULTI,
    CUSTOM_FIELD_TYPE_CAPTCHA
];

export const LEAD_TYPES = [
    'hubspot',
    'chat',
    'userspaces',
    'guestspaces',
    'question'
]

export const LEAD_STATUSES = [
    'new',
    'ase',
    'apa',
    'als',
    'ano',
    'response_client',
    'transfer_agency',
    'close'
]

export const LEAD_EXTERNAL_STATUSES = [
    'new',
    'inprogress',
    'valid',
    'close'
]

export const LEAD_HUBSPOT_STATUSES = [
    '1', //NEW
    '2', //Waiting on contact
    '3', //Waiting on us
    '4' //Closed
]

export const PERIODICITIES = periodicitiesData;
export const DEPARTMENTS = [
    { label: "Ain", id: "01" },
    { label: "Aisne", id: "02" },
    { label: "Allier", id: "03" },
    { label: "Alpes-de-Haute-Provence", id: "04" },
    { label: "Hautes-Alpes", id: "05" },
    { label: "Alpes-Maritimes", id: "06" },
    { label: "Ardèche", id: "07" },
    { label: "Ardennes", id: "08" },
    { label: "Ariège", id: "09" },
    { label: "Aube", id: "10" },
    { label: "Aude", id: "11" },
    { label: "Aveyron", id: "12" },
    { label: "Bouches-du-Rhône", id: "13" },
    { label: "Calvados", id: "14" },
    { label: "Cantal", id: "15" },
    { label: "Charente", id: "16" },
    { label: "Charente-Maritime", id: "17" },
    { label: "Cher", id: "18" },
    { label: "Corrèze", id: "19" },
    { label: "Corse-du-Sud", id: "2A" },
    { label: "Haute-Corse", id: "2B" },
    { label: "Côte-d'Or", id: "21" },
    { label: "Côtes-d'Armor", id: "22" },
    { label: "Creuse", id: "23" },
    { label: "Dordogne", id: "24" },
    { label: "Doubs", id: "25" },
    { label: "Drôme", id: "26" },
    { label: "Eure", id: "27" },
    { label: "Eure-et-Loir", id: "28" },
    { label: "Finistère", id: "29" },
    { label: "Gard", id: "30" },
    { label: "Haute-Garonne", id: "31" },
    { label: "Gers", id: "32" },
    { label: "Gironde", id: "33" },
    { label: "Hérault", id: "34" },
    { label: "Ille-et-Vilaine", id: "35" },
    { label: "Indre", id: "36" },
    { label: "Indre-et-Loire", id: "37" },
    { label: "Isère", id: "38" },
    { label: "Jura", id: "39" },
    { label: "Landes", id: "40" },
    { label: "Loir-et-Cher", id: "41" },
    { label: "Loire", id: "42" },
    { label: "Haute-Loire", id: "43" },
    { label: "Loire-Atlantique", id: "44" },
    { label: "Loiret", id: "45" },
    { label: "Lot", id: "46" },
    { label: "Lot-et-Garonne", id: "47" },
    { label: "Lozère", id: "48" },
    { label: "Maine-et-Loire", id: "49" },
    { label: "Manche", id: "50" },
    { label: "Marne", id: "51" },
    { label: "Haute-Marne", id: "52" },
    { label: "Mayenne", id: "53" },
    { label: "Meurthe-et-Moselle", id: "54" },
    { label: "Meuse", id: "55" },
    { label: "Morbihan", id: "56" },
    { label: "Moselle", id: "57" },
    { label: "Nièvre", id: "58" },
    { label: "Nord", id: "59" },
    { label: "Oise", id: "60" },
    { label: "Orne", id: "61" },
    { label: "Pas-de-Calais", id: "62" },
    { label: "Puy-de-Dôme", id: "63" },
    { label: "Pyrénées-Atlantiques", id: "64" },
    { label: "Hautes-Pyrénées", id: "65" },
    { label: "Pyrénées-Orientales", id: "66" },
    { label: "Bas-Rhin", id: "67" },
    { label: "Haut-Rhin", id: "68" },
    { label: "Rhône", id: "69" },
    { label: "Haute-Saône", id: "70" },
    { label: "Saône-et-Loire", id: "71" },
    { label: "Sarthe", id: "72" },
    { label: "Savoie", id: "73" },
    { label: "Haute-Savoie", id: "74" },
    { label: "Paris", id: "75" },
    { label: "Seine-Maritime", id: "76" },
    { label: "Seine-et-Marne", id: "77" },
    { label: "Yvelines", id: "78" },
    { label: "Deux-Sèvres", id: "79" },
    { label: "Somme", id: "80" },
    { label: "Tarn", id: "81" },
    { label: "Tarn-et-Garonne", id: "82" },
    { label: "Var", id: "83" },
    { label: "Vaucluse", id: "84" },
    { label: "Vendée", id: "85" },
    { label: "Vienne", id: "86" },
    { label: "Haute-Vienne", id: "87" },
    { label: "Vosges", id: "88" },
    { label: "Yonne", id: "89" },
    { label: "Territoire de Belfort", id: "90" },
    { label: "Essonne", id: "91" },
    { label: "Hauts-de-Seine", id: "92" },
    { label: "Seine-St-Denis", id: "93" },
    { label: "Val-de-Marne", id: "94" },
    { label: "Val-D'Oise", id: "95" },
    { label: "Guadeloupe", id: "971" },
    { label: "Martinique", id: "972" },
    { label: "Guyane", id: "973" },
    { label: "La Réunion", id: "974" },
    { label: "Mayotte", id: "976" },
]
export const REGIONS = [
    { label: "Ile-de-France", id: "001", tax: 1.1 },
    { label: "Nouvelle-Aquitaine", id: "002" },
    { label: "Guadeloupe", id: "003", tax: 1.15 },
    { label: "Martinique", id: "004", tax: 1.15 },
    { label: "Guyane", id: "005", tax: 1.15 },
    { label: "La Réunion", id: "006", tax: 1.15 },
    { label: "Mayotte", id: "007" },
    { label: "DROM-COM", id: "008" },
    { label: "Bretagne", id: "009" },
    { label: "Pays de la Loire", id: "010" },
    { label: "Hauts-de-France", id: "011" },
    { label: "Corse", id: "012" },
    { label: "Provence-Alpes-Côte d'Azur", id: "013" },
    { label: "Normandie", id: "014" },
    { label: "Grand Est", id: "015" },
    { label: "Bourgogne-Franche-Comté", id: "016" },
    { label: "Auvergne-Rhône-Alpes", id: "017" },
    { label: "Occitanie", id: "018" },
    { label: "Centre-Val de Loire", id: "019" }
]

export const UserInfoFields = {
    firstName: 'first_name',
    lastName: 'last_name',
    email: 'email',
    company: 'company',
    phone: 'phone',
    zipCode: 'zipcode',
    position: 'position',
    address: 'address',
    city: 'city',
    country: 'country'
}